import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { chooseLanguage } from '../i18n';

export interface FooterProps {
  fixedPosition?: boolean;
  // Only the onboarding checklist is translated, so the switch only shows there.
  showLanguage?: boolean;
}

const Footer = ({ fixedPosition = false, showLanguage = false }: FooterProps) => {
    const { i18n } = useTranslation();
    // Always written in the other language, so the reader who needs it can find it.
    const other = i18n.language === 'es' ? { lng: 'en', label: 'View in English' } : { lng: 'es', label: 'Ver en español' };
    return (
        <StyledContainer className={fixedPosition ? "fixed-position" : ""}>
            <p>© 2026 Phervent Brands, Inc. All Rights Reserved.</p>
            {showLanguage && (
                <button type="button" className="lang" lang={other.lng} onClick={() => chooseLanguage(other.lng)}>
                    {other.label}
                </button>
            )}
        </StyledContainer>
    );
};

export const StyledContainer = styled.div`
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #595959;
    font-size: x-small;

    .lang {
        margin-bottom: 12px;
        padding: 0;
        border: none;
        background: none;
        color: #595959;
        font-size: 9px;
        text-decoration: underline;
        cursor: pointer;
    }
`;

export default Footer;
